/* ===== Header Desktop Navigation (Prestige → Dawn 移植JS統合) ===== */
(function() {
  var root = document.querySelector('.Header__MainNav');
  if (!root) return;

  var desktopMq = window.matchMedia('(min-width: 1280px)');
  function isDesktop() { return desktopMq.matches; }
  var scrollbarStyleInjected = false;

  // 初期状態の安全セット
  function setupInitialState() {
    root.querySelectorAll('.DropdownMenu').forEach(function(panel) {
      if (!panel.hasAttribute('aria-hidden')) panel.setAttribute('aria-hidden', 'true');
    });
    root.querySelectorAll('.HorizontalList__Item[aria-haspopup="true"]').forEach(function(item) {
      if (!item.hasAttribute('aria-expanded')) item.setAttribute('aria-expanded', 'false');
    });
  }

  function openTopItem(item, panel) {
    item.classList.add('is-expanded');
    item.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');

    // 兄弟トップを閉じる
    var siblings = Array.prototype.filter.call(item.parentNode.children, function(c) {
      return c !== item && c.classList && c.classList.contains('HorizontalList__Item');
    });
    siblings.forEach(function(sib) {
      sib.classList.remove('is-expanded');
      sib.setAttribute('aria-expanded', 'false');
      var sibPanel = sib.querySelector(':scope > .DropdownMenu');
      if (sibPanel) sibPanel.setAttribute('aria-hidden', 'true');
    });

    applyScrollForTopDropdown(panel);
    applyReversedIfOverflow(panel);
  }

  function closeTopItem(item, panel) {
    item.classList.remove('is-expanded');
    item.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  function openSubItem(li, subPanel) {
    if (subPanel) subPanel.setAttribute('aria-hidden', 'false');
    // 必要なら第3階層も反転ロジックを適用：applyReversedIfOverflow(subPanel);
  }

  function closeSubItem(li, subPanel) {
    if (subPanel) subPanel.setAttribute('aria-hidden', 'true');
  }

  function applyReversedIfOverflow(panel) {
    if (!panel) return;
    panel.classList.remove('DropdownMenu--reversed');
    var rect = panel.getBoundingClientRect();
    var overflowRight = rect.right > window.innerWidth;
    if (overflowRight) {
      panel.classList.add('DropdownMenu--reversed');
    }
  }

  function applyScrollForTopDropdown(panel) {
    if (!panel || !panel.classList || !panel.classList.contains('d-1')) return;
    var hasThirdLevel = panel.querySelector('.DropdownMenu');
    var list = panel.querySelector(':scope > .Linklist');
    if (!list) return;
    if (hasThirdLevel) {
      panel.style.maxHeight = '';
      panel.style.overflowY = '';
      panel.style.overscrollBehaviorY = '';
      panel.style.paddingTop = '';
      panel.style.paddingBottom = '';
      list.style.maxHeight = '';
      list.style.overflowY = '';
      list.style.overscrollBehaviorY = '';
      list.style.padding = '';
      list.style.boxSizing = '';
      return;
    }
    ensureScrollStyle();
    panel.style.maxHeight = '';
    panel.style.overflowY = '';
    panel.style.overscrollBehaviorY = '';
    panel.style.paddingTop = '0';
    panel.style.paddingBottom = '0';
    list.style.maxHeight = '369px';
    list.style.overflowY = 'auto';
    list.style.overscrollBehaviorY = 'contain';
    list.style.padding = '25px 0';
    list.style.boxSizing = 'border-box';
  }

  function ensureScrollStyle() {
    if (scrollbarStyleInjected) return;
    var style = document.createElement('style');
    style.type = 'text/css';
    style.textContent = [
      '.Header__MainNav .DropdownMenu.d-1 > .Linklist::-webkit-scrollbar{width:5px;padding:3px;}',
      '.Header__MainNav .DropdownMenu.d-1 > .Linklist::-webkit-scrollbar-track{background:#ee7a00;}',
      '.Header__MainNav .DropdownMenu.d-1 > .Linklist::-webkit-scrollbar-thumb{background-color:#ffffff;border-radius:5px;margin-right:10px;}'
    ].join('');
    document.head.appendChild(style);
    scrollbarStyleInjected = true;
  }

  // --- トップレベル（第1→第2階層） ---
  root.querySelectorAll('.HorizontalList__Item[aria-haspopup="true"]').forEach(function(item) {
    var link = item.querySelector(':scope > a');
    var panel = item.querySelector(':scope > .DropdownMenu');
    if (!link || !panel) return;

    // 初期閉じ
    closeTopItem(item, panel);

    // hover
    item.addEventListener('mouseenter', function() {
      if (!isDesktop()) return;
      openTopItem(item, panel);
    });
    item.addEventListener('mouseleave', function() {
      if (!isDesktop()) return;
      closeTopItem(item, panel);
    });

    // focus（キーボード）
    link.addEventListener('focus', function() {
      if (!isDesktop()) return;
      openTopItem(item, panel);
    });
    panel.addEventListener('focusin', function() {
      if (!isDesktop()) return;
      openTopItem(item, panel);
    });
    panel.addEventListener('focusout', function(e) {
      if (!isDesktop()) return;
      if (!panel.contains(e.relatedTarget)) closeTopItem(item, panel);
    });

    // タッチ：1タップ開く→2タップ遷移
    link.addEventListener('click', function(e) {
      var isTouchLike = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;
      if (!isTouchLike) return;
      var opened = panel.getAttribute('aria-hidden') === 'false';
      if (!opened) {
        e.preventDefault();
        openTopItem(item, panel);
      }
    });
  });

  // --- 第2階層（→ 第3階層） ---
  root.querySelectorAll('.DropdownMenu .Linklist__Item[aria-haspopup="true"]').forEach(function(li) {
    var subLink = li.querySelector(':scope > .Link.Link--secondary');
    var subPanel = li.querySelector(':scope > .DropdownMenu');
    if (!subLink || !subPanel) return;

    subPanel.setAttribute('aria-hidden', 'true');

    // hover
    li.addEventListener('mouseenter', function() {
      if (!isDesktop()) return;
      openSubItem(li, subPanel);
    });
    li.addEventListener('mouseleave', function() {
      if (!isDesktop()) return;
      closeSubItem(li, subPanel);
    });

    // focus（キーボード）
    subLink.addEventListener('focus', function() {
      if (!isDesktop()) return;
      openSubItem(li, subPanel);
    });
    subPanel.addEventListener('focusout', function(e) {
      if (!isDesktop()) return;
      if (!subPanel.contains(e.relatedTarget)) closeSubItem(li, subPanel);
    });

    // タッチ：1タップ開く→2タップ遷移
    subLink.addEventListener('click', function(e) {
      var isTouchLike = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;
      if (!isTouchLike) return;
      var opened = subPanel.getAttribute('aria-hidden') === 'false';
      if (!opened) {
        e.preventDefault();
        openSubItem(li, subPanel);
      }
    });
  });

  // ヘッダー外へ出たら全閉
  var header = root.closest('.Header') || document.querySelector('header');
  if (header) {
    header.addEventListener('mouseleave', function() {
      root.querySelectorAll('.HorizontalList__Item[aria-haspopup="true"]').forEach(function(item) {
        var panel = item.querySelector(':scope > .DropdownMenu');
        closeTopItem(item, panel);
      });
      root.querySelectorAll('.DropdownMenu .Linklist__Item[aria-haspopup="true"] > .DropdownMenu').forEach(function(p) {
        p.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // リサイズ時、開いているパネルの反転再計算
  window.addEventListener('resize', function() {
    if (!isDesktop()) return;
    root.querySelectorAll('.HorizontalList__Item[aria-haspopup="true"] > .DropdownMenu[aria-hidden="false"]').forEach(applyReversedIfOverflow);
  });

  // 初期セット
  setupInitialState();
})();
